
import { useContext } from "react";
import { createContext, useState } from "react";

export const DataContext = createContext()

export function DataContextProvider(props){
    const [esJefe, setEsJefe] = useState(false)
    const [openAvisos, setOpenAvisos] = useState(false)
    const [esAsistente, setEsAsistente] = useState(false)
    const [esJefeCaja, setEsJefeCaja] = useState(false)
    const [usuario, setUsuario] = useState({
        id: '',
        password: ''
    })
    const [entidad, setEntidad] = useState({nombre:''})

    const [esMenu, setEsMenu] = useState(false)

    const [plan, setPlan] =useState(null)
    const valor = { esJefe, setEsJefe, esAsistente, setEsAsistente, usuario, setUsuario, openAvisos, setOpenAvisos, entidad, setEntidad, plan, setPlan, esMenu, setEsMenu, esJefeCaja, setEsJefeCaja}

    return(<DataContext.Provider value={valor}>{props.children}</DataContext.Provider>)
}

export function useDataContext () {
    const context = useContext(DataContext)
    if(!context){
        throw new Error('useDataContext must be used within a DataContextProvider')        
    }
    return context;
}